class FAQAccordion extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', event => {
			this.handleTriggerclick2(event);
		}, true);
	}

	// handleTriggerClick({ currentTarget }) {
	// 	const activeAccordion = document.querySelector('.active.accordion-group');

	// 	if (activeAccordion && activeAccordion != currentTarget.parentElement) {
	// 		activeAccordion.classList.remove('active');
	// 		activeAccordion.querySelector('.drawer').removeAttribute('style');
	// 	}

	// 	const drawerEl = currentTarget.nextElementSibling;

	// 	drawerEl.getAttribute('style')
	// 		? drawerEl.removeAttribute('style')
	// 		: drawerEl.style.height = `auto`;

	// 	currentTarget.parentElement.classList.toggle('active');
	// }

	handleTriggerclick2(event) {
		const { target } = event;

		if(target.classList.contains('trigger')) {
			if(target.classList.contains('active')) {
				target.classList.remove('active');
				target.nextElementSibling.removeAttribute('style');
				return;
			}

			this.querySelectorAll('.trigger').forEach(el => {
				el.classList.toggle('active', el == target);

				if(el == target) {
					el.nextElementSibling.style.height = `${el.nextElementSibling.scrollHeight}px`;
				} else {
					el.nextElementSibling.removeAttribute('style');
				}
			});

			setTimeout(() => {
				const scrollYOffset = target.offsetTop - document.querySelector('header').clientHeight;

				window.scroll({
					top: scrollYOffset,
					behavior: 'smooth',
				})
			}, 200);
		}
	}
}

customElements.define('faq-accordion', FAQAccordion)
